import { ANALYTICS_EVENTS } from '../events'
import createAnalyticsStatic, { EventProps } from './createAnalyticsEvent'

export type ChatButtonClickedProps = EventProps

/**
 * @event Chat_button_clicked
 * @description Emitted when the chat button is clicked.
 */
export const ChatButtonClickedAnalytics = createAnalyticsStatic<ChatButtonClickedProps>(
    ANALYTICS_EVENTS.CHAT_BUTTON_CLICKED,
)

export default ChatButtonClickedAnalytics
